import axios from 'axios';
import host from '../global';
import Cookies from 'js-cookie';

const getAuthHeader = () => ({
  Authorization: `Bearer ${Cookies.get('accessToken')}`,
});

export const fetchFirstRunGuideStatusService = async () => {
  const response = await axios.get(`${host}/api/first-run-guide/status`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

// event: "job_created" | "completed" | "dismissed" | "restart"
export const postFirstRunGuideEventService = async (event) => {
  const response = await axios.post(
    `${host}/api/first-run-guide/event`,
    { event },
    { headers: getAuthHeader() },
  );
  return response.data;
};
